import classNames from "classnames/bind";
import { Skeleton } from "primereact/skeleton";
import classes from "./FormSkeleton.module.scss";

interface FormSkeletonProps {
  rows?: number;
}

const FormSkeleton: React.FC<FormSkeletonProps> = ({
  rows = 3,
}): React.ReactElement => {
  const cx = classNames.bind(classes);

  return (
    <div className={cx(classes.formSkeleton)}>
      {/* TODO: refactor to different loop */}
      {[...Array(rows)].map((x, i) => (
        <div key={i}>
          <Skeleton
            className={cx(classes.label)}
            height="14px"
            width="100px"
          ></Skeleton>
          <Skeleton className={cx(classes.input)} height="37px"></Skeleton>
        </div>
      ))}
      <Skeleton
        className={cx(classes.button)}
        height="37px"
        width="64px"
      ></Skeleton>
    </div>
  );
};

export default FormSkeleton;
